// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._920456>:nth-child(1){--checked-color: #54bf26}._920456>:nth-child(2){--checked-color: #bacc28}._920456>:nth-child(3){--checked-color: #f7c705}._920456>:nth-child(4){--checked-color: #ffac00}._920456>:nth-child(5){--checked-color: red}", ""]);
// Exports
exports.locals = {
	"radio-group": "_920456",
	"radioGroup": "_920456"
};
module.exports = exports;
